import { render, staticRenderFns } from "./ProductEditWoo.vue?vue&type=template&id=4539ce9d&"
import script from "./ProductEditWoo.vue?vue&type=script&lang=js&"
export * from "./ProductEditWoo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports